// Blank-start landing overlay: blocks interaction with the map/tools until a project is
// explicitly activated (Resume or a fresh pick), so a page refresh can never leave a live,
// clickable project sitting under the cursor. See context.js's getActiveProject() (always
// null until setActiveProject() is called) / getPendingResumeProject() (the last-active
// project, offered as a one-click suggestion, never applied automatically).
export function createLandingOverlay({ rootEl, events, context }) {
  let el = null;
  let dismissedForBrowse = false;

  function ensureEl() {
    if (el) return el;
    el = document.createElement("div");
    el.className = "hydrotools-landing";
    el.style.cssText = `
      position:fixed; inset:0; z-index:100000; display:flex; align-items:center; justify-content:center;
      background:radial-gradient(ellipse at center, rgba(15,23,42,.72) 0%, rgba(2,6,23,.88) 100%);
      backdrop-filter:blur(3px); -webkit-backdrop-filter:blur(3px);
    `;
    el.innerHTML = `
      <div style="width:min(420px, 90vw); background:rgba(15,23,42,.98); border:1px solid rgba(148,163,184,.24); border-radius:14px; box-shadow:0 24px 64px rgba(0,0,0,.55); padding:32px 28px; text-align:center;">
        <div style="font-size:22px; font-weight:700; color:#e2e8f0; letter-spacing:.02em;">HydroTools</div>
        <div data-landing-sub style="margin-top:10px; font-size:13px; color:var(--muted); line-height:1.5;"></div>
        <div style="margin-top:22px; display:flex; flex-direction:column; gap:10px;">
          <button type="button" class="btn primary" data-landing-resume style="display:none; padding:10px 16px; font-size:13px; border-radius:8px;"></button>
          <button type="button" class="btn" data-landing-browse style="padding:10px 16px; font-size:13px; border-radius:8px;">Browse Projects</button>
        </div>
      </div>
    `;
    (rootEl || document.body).appendChild(el);
    el.querySelector("[data-landing-resume]")?.addEventListener("click", () => {
      const pending = context?.getPendingResumeProject?.();
      if (pending) context.setActiveProject(pending.id);
    });
    el.querySelector("[data-landing-browse]")?.addEventListener("click", () => {
      dismissedForBrowse = true;
      hide();
      const panel = document.querySelector('[data-tool-id="marina-portfolio-manager"]');
      if (panel) {
        panel.setAttribute("open", "");
        panel.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
    return el;
  }

  function hide() {
    if (el) el.style.display = "none";
  }

  function render() {
    const active = context?.getActiveProject?.();
    if (active) { hide(); return; }
    if (dismissedForBrowse) return;
    const node = ensureEl();
    const pending = context?.getPendingResumeProject?.();
    const sub = node.querySelector("[data-landing-sub]");
    const resumeBtn = node.querySelector("[data-landing-resume]");
    if (sub) {
      sub.textContent = pending
        ? `Resume ${pending.name}, or choose a different project to begin.`
        : "Choose a project to begin.";
    }
    if (resumeBtn) {
      if (pending) {
        resumeBtn.style.display = "";
        resumeBtn.textContent = `Resume ${pending.name}`;
      } else {
        resumeBtn.style.display = "none";
      }
    }
    node.style.display = "flex";
  }

  render();
  events?.on?.("context:changed", render);

  return { render };
}
